<script>
  import {
    Parse,
    miniToastr
  } from '../../Global'
  
  export function handleParseError (self, error) {
    miniToastr.error(error.message)
    switch (error.code) {
      case Parse.Error.INVALID_SESSION_TOKEN:
        Parse.User.logOut()
        self.$router.push('/login?next=')
        break
        // Other Parse API errors that you want to explicitly handle
    }
  }
  
</script>



// WEBPACK FOOTER //
// ErrorHandling.vue?e7c2b6e2